import { memo } from 'react';

import { unescapeChars, Collapse, TextLink, Clamp, colors } from '@crehana/ui';

import ArrowIosDownOutline from '@crehana/icons/dist/ArrowIosDownOutline';
import ArrowIosUpOutline from '@crehana/icons/dist/ArrowIosUpOutline';
import ChevronRightFilled from '@crehana/icons/dist/ChevronRightFilled';

import { CoursesSectionItemProps } from './types';
import { CourseItemWrapper } from './CoursesSectionItem.styles';

const CoursesSectionItem: React.FC<
  React.PropsWithChildren<CoursesSectionItemProps>
> = ({ open, onOpen, course, onOpenVideo }) => (
  <CourseItemWrapper className="bg-gray-lighter">
    <button
      type="button"
      className="text-left relative pt-32 pb-24 pl-24 pr-24 w-full"
      onClick={() => {
        onOpen(!open ? course.originalId : null);
      }}
    >
      <div>
        <h3 className="font-subtitle2 mb-4">{course.title}</h3>
        <div className="font-legals">
          {course.professor?.fullName} | {course.professor?.occupation}
        </div>
      </div>
      <div className="absolute top-0 right-0 p-4 md:p-20">
        {open ? (
          <ArrowIosUpOutline color={colors.primaryMain} size={24} />
        ) : (
          <ArrowIosDownOutline size={24} />
        )}
      </div>
    </button>
    <Collapse open={open} className="flex flex-col items-start px-24 pb-24">
      {course.shortDescriptionWithoutHtml ? (
        <Clamp clamp={3} className="font-body4 mb-16">
          {unescapeChars(course.shortDescriptionWithoutHtml)}
        </Clamp>
      ) : null}
      <TextLink
        onClick={() => {
          onOpenVideo({
            originalId: course.originalId,
            title: course.title,
            promoVideoHashedId: course.promoVideoHashedId,
            promoImage: course.promoImage,
            imagePlaceholder: course.imagePlaceholder,
            trailerSource: course.trailerSource,
            professor: course.professor,
          });
        }}
        className="text-primary-light"
        label="Ver trailer"
        leftIcon={{
          component: ChevronRightFilled,
          size: 24,
        }}
        type="level1"
      />
    </Collapse>
  </CourseItemWrapper>
);

export default memo(CoursesSectionItem);
